export default "__VITE_ASSET__3ebd9f5c__"